import React, { useState, useEffect } from 'react';
import { db } from '../db';
import EventCard from '../components/EventCard';
import CategoryFilter from '../components/CategoryFilter';
import { FaSearch, FaSort, FaFilter } from 'react-icons/fa';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [view, setView] = useState('recent');
  const [sortBy, setSortBy] = useState('start_date');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    const storedEvents = await db.events.toArray();
    setEvents(storedEvents);
    const uniqueCategories = [...new Set(storedEvents.map(event => event.category))].filter(Boolean);
    setCategories(['All', ...uniqueCategories]);
  };

  const handleViewChange = (newView) => {
    setView(newView);
  };

  const filteredEvents = events
    .filter(event => selectedCategory === 'All' || event.category === selectedCategory)
    .filter(event => event.title.toLowerCase().includes(searchTerm.toLowerCase()));

  const displayedEvents = view === 'recent' 
    ? filteredEvents.filter(event => !event.done)
    : filteredEvents.filter(event => event.done);

  const sortedEvents = [...displayedEvents].sort((a, b) => {
    let dateA, dateB;
    if (sortBy === 'start_date') {
      dateA = new Date(a.start_date);
      dateB = new Date(b.start_date);
    } else if (sortBy === 'created_date') {
      dateA = new Date(a.created_date);
      dateB = new Date(b.created_date);
    } else if (sortBy === 'updated_date') {
      dateA = new Date(a.updated_date || a.created_date);
      dateB = new Date(b.updated_date || b.created_date);
    }
    return dateA - dateB;
  });

  const handleDeleteAll = async () => {
    if (window.confirm('Are you sure you want to delete all events? This action cannot be undone.')) {
      await db.events.clear();
      setEvents([]);
      setCategories(['All']);
    }
  };

  return (
    <div className="flex flex-col h-full bg-gray-100">
      <div className="sticky top-0 z-10 bg-white shadow-md">
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold">Events</h2>
            <button
              onClick={handleDeleteAll}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
            >
              Delete All
            </button>
          </div>

          <div className="flex items-center space-x-4 mb-4">
            <div className="flex-grow flex items-center bg-white border rounded-lg px-3 py-2">
              <FaSearch className="text-gray-400 mr-2" />
              <input
                type="text"
                placeholder="Search events..."
                className="w-full focus:outline-none"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex items-center space-x-2">
              <button 
                onClick={() => handleViewChange('recent')}
                className={`px-3 py-2 rounded ${view === 'recent' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
              >
                Recent
              </button>
              <button 
                onClick={() => handleViewChange('done')}
                className={`px-3 py-2 rounded ${view === 'done' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
              >
                Done
              </button>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center bg-white border rounded-lg px-3 py-2">
              <FaFilter className="text-gray-400 mr-2" />
              <CategoryFilter 
                categories={categories}
                selectedCategory={selectedCategory}
                onCategoryChange={setSelectedCategory}
              />
            </div>
            <div className="flex items-center bg-white border rounded-lg px-3 py-2">
              <FaSort className="text-gray-400 mr-2" />
              <select 
                value={sortBy} 
                onChange={(e) => setSortBy(e.target.value)} 
                className="bg-transparent focus:outline-none"
              >
                <option value="start_date">Start Date</option>
                <option value="created_date">Created Date</option>
                <option value="updated_date">Updated Date</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="px-4 py-4">
          <ul className="space-y-4">
            {sortedEvents.length === 0 ? (
              <li>No events to display.</li>
            ) : (
              sortedEvents.map((event) => (
                <li key={event.id}>
                  <EventCard 
                    event={event} 
                    onEventUpdated={loadEvents}
                    isInChatView={false}
                  />
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Events;